import { Capacitor } from '@capacitor/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { ActionSheet } from '@capacitor/action-sheet';

/**
 * 현재 플랫폼이 네이티브인지 확인
 */
export const isNative = () => {
  return Capacitor.isNativePlatform();
};

/**
 * 현재 플랫폼 반환
 */
export const getPlatform = () => {
  return Capacitor.getPlatform(); // 'web', 'android', 'ios'
};

/**
 * 인스타 스타일 사진 선택 (카메라 or 앨범)
 */
export const selectPhoto = async () => {
  if (!isNative()) {
    // 웹에서는 기본 파일 선택
    return null;
  }

  try {
    // 액션 시트로 선택지 제공
    const result = await ActionSheet.showActions({
      title: '사진 추가',
      message: '사진을 선택하거나 촬영하세요',
      options: [
        {
          title: '카메라로 촬영',
        },
        {
          title: '앨범에서 선택',
        },
        {
          title: '취소',
          style: 'cancel',
        },
      ],
    });

    if (result.index === 2) {
      // 취소
      return null;
    }

    const source = result.index === 0 ? CameraSource.Camera : CameraSource.Photos;

    // 사진 촬영/선택
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: true,
      resultType: CameraResultType.Uri,
      source: source,
      correctOrientation: true, // 자동 회전 수정
      saveToGallery: source === CameraSource.Camera, // 촬영한 사진은 갤러리에 저장
    });

    return image;
  } catch (error) {
    console.error('사진 선택 실패:', error);
    return null;
  }
};

/**
 * 카메라로 직접 촬영
 */
export const takePhoto = async () => {
  if (!isNative()) {
    return null;
  }

  try {
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: true,
      resultType: CameraResultType.Uri,
      source: CameraSource.Camera,
      correctOrientation: true,
      saveToGallery: true,
    });

    return image;
  } catch (error) {
    console.error('사진 촬영 실패:', error);
    return null;
  }
};

/**
 * 앨범에서 사진 선택
 */
export const pickPhoto = async () => {
  if (!isNative()) {
    return null;
  }

  try {
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: true,
      resultType: CameraResultType.Uri,
      source: CameraSource.Photos,
      correctOrientation: true,
    });

    return image;
  } catch (error) {
    console.error('사진 선택 실패:', error);
    return null;
  }
};

/**
 * 이미지 URI를 Blob으로 변환
 */
export const uriToBlob = async (uri) => {
  const response = await fetch(uri);
  const blob = await response.blob();
  return blob;
};

/**
 * 이미지 URI를 File 객체로 변환
 */
export const uriToFile = async (uri, fileName = 'photo.jpg') => {
  const blob = await uriToBlob(uri);
  return new File([blob], fileName, { type: blob.type });
};








